import { ClientBrandCode, RequestAction } from '@domgen/dgx-fe-common';
import { RegistrationFeatures } from './registration-features.type';
import { RegistrationPartsWarranty } from './registration-parts-warranty.interface';

export interface RegistrationConfig {
  adobeCampaignApi?: string;
  adobeCampaignApiKey?: string;
  adobeCampaignBrand?: string;
  adobeCampaignEventType?: string;
  applianceLookupUrlBase?: string;
  applianceMaximumAgeInMonths: number;
  applianceRegistrationLimit: number;
  checkoutApi: string;
  callCentreNumber: string;
  clientBrandCode?: ClientBrandCode;
  commonApi: string;
  cpgFinderApi?: string;
  defaultApplianceCategoryCode?: string;
  defaultWarranty?: Record<string, number>;
  features: RegistrationFeatures;
  modelNumberSearchEnabledBrands: ClientBrandCode[];
  partsWarranty?: Record<string, RegistrationPartsWarranty>;
  possibleNowApi?: string;
  possibleNowFilterId?: string;
  possibleNowSalt: string;
  registrationApi?: string;
  registrationBaseUrl?: string;
  registriaUsersApi?: string;
  requestAction?: RequestAction;
  retailerDomain: string;
  retailerFieldEnabledBrands: ClientBrandCode[];
  serializationApi?: string;
  usaServiceBaseUrl?: string;
  warrantyLengthInYears?: number;
  warrantyMaximumLengthInMonths?: number;
  wibApi?: string;
  preWibApi?: string;
}
